import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const CmsContentPageContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ContentPageContainer" */
      './CmsContentPageContainer.dynamic'
    ),
  loading: LoadingPageLoadable,
});
